/** Resolve a Stringers media path to an absolute same-origin URL. */
export function resolveMediaUrl(mediaUrl) {
  if (!mediaUrl) return null;
  if (/^https?:\/\//i.test(mediaUrl)) return mediaUrl;
  const path = mediaUrl.startsWith('/') ? mediaUrl : `/${mediaUrl}`;
  // Stored as /media/... under servlet context /api → /api/media/...
  if (path.startsWith('/api/')) {
    return `${window.location.origin}${path}`;
  }
  if (path.startsWith('/media/')) {
    return `${window.location.origin}/api${path}`;
  }
  return `${window.location.origin}${path}`;
}
